module.exports = __webpack_public_path__ + "static/media/leaf-small.752d1887.svg";